<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      {{ $t('common_words.farm_division') }}
    </p>
    <hr />
    <div class="row" style="padding-left: 19px">
      <div class="col-12 col-md-6 col-lg-4">
        <div class="form-group has-label my-0 pb-1 pt-3 sticky-button">
          <minus-plus
            :label="`${$t('common_words.blocks_number')}: *`"
            @handlePlus="handlePlusBlock"
            @handleMinus="handleMinusBlock"
            :value="model.blocks_number"
          />
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-7" v-if="getNumberBlocks">
        <span v-for="index in getNumberBlocks" :key="index">
          <fg-input
            class="required-fourth-step"
            v-model="model.name_blocks[index - 1]"
            type="text"
            :label="$t('common_words.block_name')"
            :placeholder="$t('common_words.block_number_one')"
            @change="model.blocks_rel = []"
          ></fg-input>
        </span>
      </div>
    </div>
    <hr />
    <div class="row sticky-button px-1 mb-2">
      <div class="col-12 col-md-6 col-lg-4">
        <div class="form-group has-label">
          <minus-plus
            :label="`${$t('common_words.allotment_number')}: *`"
            mr="2rem !important"
            @handlePlus="handlePlusLot"
            @handleMinus="handleMinusLot"
            :value="model.lots_number"
          />
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4">
        <div class="form-group has-label">
          <label class="mr-2 mb-0">{{
            $t('common_words.allotment_code')
          }}</label>
          <br />
          <el-switch
            v-model="model.has_lot_code"
            active-color="#6BA652"
            inactive-color="#ff4949"
            :active-text="$t('common_words.yes')"
            :inactive-text="$t('common_words.no')"
            @change="handleChangeHasLotCode"
          >
          </el-switch>
        </div>
      </div>
    </div>
    <div
      class="row border rounded-sm shadow-sm mb-3 py-2"
      v-for="index in getNumberLots"
      :key="index"
      style="background-color: #fcfffb !important"
    >
      <div
        v-if="model.has_lot_code"
        class="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-1"
      >
        <fg-input
          class="required-fourth-step"
          v-model="model.code_lots[index - 1]"
          type="text"
          :label="$t('common_words.code')"
          :placeholder="`${$t('common_words.code')} N°${index}`"
          @change="validateRepeatedCode"
        ></fg-input>
      </div>
      <div
        :class="
          model.has_lot_code
            ? 'col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2'
            : 'col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2'
        "
      >
        <fg-input
          class="required-fourth-step"
          v-model="model.name_lots[index - 1]"
          type="text"
          :label="$t('common_words.allotment_name')"
          :placeholder="`${$t('common_words.allotment')} N°${index}`"
          @change="model.lots_rel = []"
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
        <fg-input
          class="required-fourth-step"
          :precision="2"
          :step="0.1"
          :max="10"
          :min="0"
          type="number"
          :label="`${$t('common_words.area')} (${area_unit})`"
          placeholder="12.34"
          v-model="model.area_lots[index - 1]"
        ></fg-input>
      </div>
      <div
        :class="
          model.has_lot_code
            ? 'col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2'
            : 'col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3'
        "
      >
        <div class="form-group">
          <label>{{ $t('common_words.variety') }}</label>
          <br />
          <el-select
            clearable
            filterable
            class="select-primary custom-width-select required-fourth-step shadow-sm"
            size="large"
            v-model.number="model.crop_varieties_id[index - 1]"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in avaliableVarieties"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.name + option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
        <div class="form-group">
          <label style="width: 100%">
            {{ $t('common_words.soil_type') }}
            <el-tooltip
              effect="dark"
              placement="top"
              v-if="model.soilTypes[index - 1]"
            >
              <div
                slot="content"
                style="width: 200px"
                v-html="getSoilTypeInfo(index - 1)"
              ></div>
              <div class="none cursors float-right">
                <i class="el-icon-info"></i>
              </div>
            </el-tooltip>
          </label>
          <br />
          <el-select
            clearable
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model.number="model.soilTypes[index - 1]"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <template v-for="option in soilTypes">
              <el-tooltip
                v-if="option.image"
                :key="option.name"
                effect="dark"
                placement="left"
              >
                <div
                  slot="content"
                  :style="`width: 200px; ${
                    option.image ? 'margin: -11px; border-radius: 4px' : ''
                  }`"
                >
                  <img
                    v-if="option.image"
                    class="my-3"
                    :src="getSrc(option.image, 'soil_images')"
                    style="
                      width: 100%;
                      margin-top: 0 !important;
                      margin-bottom: 0 !important;
                    "
                  />
                  <template v-else-if="option.description">{{
                    option.description
                  }}</template>
                  <template v-else>{{
                    $t('common_words.without_info')
                  }}</template>
                </div>
                <el-option
                  class="select-primary"
                  :value="option.id"
                  :label="option.name"
                ></el-option>
              </el-tooltip>
              <el-option
                v-else
                :key="`${option.name}${option.id}`"
                class="select-primary"
                :value="option.id"
                :label="option.name"
              ></el-option>
            </template>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
        <fg-input
          :precision="2"
          :step="0.1"
          :max="100"
          type="number"
          :label="$t('common_words.population')"
          placeholder="180"
          v-model.number="model.population[index - 1]"
        ></fg-input>
      </div>
      <div
        class="text-center col-12 col-sm-6 col-md-3 col-lg-1 col-xl-1 pt-4"
        v-if="isDelete()"
      >
        <a
          v-if="getNumberLots > 1"
          v-tooltip.top-center="$t('common_words.erase')"
          class="btn-danger btn-simple btn-link custom-margin-actions"
          @click="handleDeleteLotByLot(index - 1)"
        >
          <em class="fa fa-times custom-size-fa-actions"></em>
        </a>
      </div>
    </div>
    <template v-if="getNumberLots">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-3 mb-2">
          <kpi
            :label="$t('common_words.area_total_ha')"
            :value="calculateArea"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-3 mb-2">
          <kpi
            :label="$t('common_words.variety_predominant')"
            :value="predominantVariety"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-3 mb-2">
          <kpi
            :label="$t('common_words.soil_predominant')"
            :value="predominantSoil"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-3 mb-2">
          <kpi
            :label="$t('common_words.population_total')"
            :value="calculatePopulation"
          />
        </div>
      </div>
    </template>
    <br />
    <p class="cm-mg-p-wzd text-center text-muted" v-if="getNumberBlocks">
      {{ $t('common_words.blocks_allotment_relation') }}
    </p>
    <hr v-if="getNumberBlocks" />
    <div class="row" v-if="getNumberBlocks">
      <div class="col-4">
        <span v-for="index in getNumberBlocks" :key="index">
          <div class="form-group">
            <label>{{ $t('common_words.blocks') }}:</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-fourth-step shadow-sm"
              size="large"
              v-model.trim="model.blocks_rel[index - 1]"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in availableBlocks"
                class="select-primary"
                :value="option"
                :label="option"
                :key="`block-${index}-${option}`"
              ></el-option>
            </el-select>
          </div>
        </span>
      </div>
      <div class="col-8">
        <span v-for="index in getNumberBlocks" :key="index">
          <div class="form-group">
            <label>{{ $t('common_words.allotment') }}: </label>
            <br />
            <el-select
              clearable
              filterable
              multiple
              collapse-tags
              class="select-primary custom-width-select lot-rels shadow-sm"
              size="large"
              v-model.trim="model.lots_rel[index - 1]"
              :placeholder="`${$t('common_words.select')}...`"
              @change="
                selectAllFromSelectLots(
                  $event,
                  `model.lots_rel[${index - 1}]`,
                  concatAllLots(model.name_lots)
                )
              "
            >
              <el-option
                v-for="(option, i) in concatAllLots(model.name_lots)"
                class="select-primary selected-all"
                :value="option.name"
                :label="option.name"
                :key="`lot-${i}-${option.id}`"
              ></el-option>
            </el-select>
          </div>
        </span>
      </div>
    </div>
    <br />
    <p class="cm-mg-p-wzd text-center text-muted" v-if="getNumberBlocks">
      {{ $t('common_words.packing_house_2') }}
    </p>
    <hr />
    <div class="row sticky-button px-1 mb-2">
      <div class="col-12 col-md-6 col-lg-5">
        <div class="form-group has-label">
          <minus-plus
            :label="`${$t('common_words.packing_house_number')}: *`"
            mr="2rem !important"
            @handlePlus="handlePlusPackingHouse"
            @handleMinus="handleMinusPackingHouse"
            :value="model.packing_house_number"
          />
        </div>
      </div>
    </div>
    <div
      class="row border rounded-sm shadow-sm mb-3 py-2"
      v-for="index in getNumberPackingHouse"
      :key="`packing-${index}`"
      style="background-color: #fcfffb !important"
    >
      <div class="col-12 col-sm-6 col-md-8 col-lg-4 col-xl-3">
        <fg-input
          type="text"
          :label="$t('common_words.code')"
          :placeholder="`${$t('common_words.packing_house')} N°${index}`"
          v-model="model.code_packing_houses[index - 1]"
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}`"
          :placeholder="`${$t('common_words.name')} N°${index}`"
          v-model="model.name_packing_houses[index - 1]"
        ></fg-input>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label>{{ $t('common_words.allotment') }}</label>
          <br />
          <el-select
            clearable
            filterable
            multiple
            collapse-tags
            class="select-primary custom-width-select lot-rels shadow-sm"
            size="large"
            v-model.trim="model.lots_packing_houses[index - 1]"
            :placeholder="`${$t('common_words.select')}...`"
            @change="
              selectAllFromSelectLots(
                $event,
                `model.lots_packing_houses[${index - 1}]`,
                concatAllLots(model.name_lots)
              )
            "
          >
            <el-option
              v-for="(option, i) in concatAllLots(model.name_lots)"
              class="select-primary selected-all"
              :value="option.name"
              :label="option.name"
              :key="`lot-${i}-${option.id}`"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import {
  getRepeatsFromArray,
  getSrcFromImage,
  getSumOfValorFromArray,
  isset,
} from 'src/util/Util.js';
import ArrayClass from 'src/class/ArrayClass';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';
import Kpi from 'src/views/Layouts/Kpi.vue';
import MinusPlus from 'src/components/Forms/MinusPlus.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import store from '@/store';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [Kpi.name]: Kpi,
    [MinusPlus.name]: MinusPlus,
  },

  data() {
    return {
      model: {
        blocks_number: null,
        lots_number: null,
        has_lot_code: false,
        packing_house_number: 0,
        id_blocks: [],
        name_blocks: [],
        id_lots: [],
        name_lots: [],
        code_lots: [],
        area_lots: [],
        code_packing_houses: [],
        name_packing_houses: [],
        lots_packing_houses: [],
        population: [],
        crop_varieties_id: [],
        soilTypes: [],
        blocks_rel: [],
        lots_rel: [],
        packing_houses: 0,
      },
      varieties_crop: [],
      modelValidations: {
        blocks_number: {
          required: true,
          max: 3,
        },
        lots_number: {
          required: true,
          max: 3,
        },
      },
      soilTypes: [],
      crop_varieties: [],
      area_unit: '',
    };
  },

  mixins: [MixinPermissions, MixinForm, MixinAlert, MixinLoading],

  watch: {
    calculateArea(newValue) {
      this.model.area = Number(newValue);
    },
    'model.has_lot_code'(val) {
      if (!val) {
        this.clearLotCodes();
      }
    },
  },

  methods: {
    handleChangeHasLotCode(val) {
      if (!val) {
        this.clearLotCodes();
      }
    },
    getEmptyLotCodes() {
      return Array.from({ length: this.getNumberLots }, () => null);
    },
    clearLotCodes() {
      this.model.code_lots = this.getEmptyLotCodes();
    },
    getPayloadCodeLots() {
      return this.model.has_lot_code
        ? this.model.code_lots.slice(0, this.getNumberLots)
        : this.getEmptyLotCodes();
    },
    getSrc(url, disk) {
      return getSrcFromImage(url, disk);
    },
    getSoilTypeInfo(index) {
      try {
        const soil = this.soilTypes.find(
          (soil) => soil.id === this.model.soilTypes[index]
        );

        const irrigationCoefficient = soil.irrigation_coefficient;
        const wiltingPoint = soil.wilting_point;
        const saturationPoint = soil.saturation_point;

        return `${i18n.t('irrigation.irrigation_coefficient')}: ${
          irrigationCoefficient
            ? Formatter.formatNumber(irrigationCoefficient)
            : '-'
        }
        <br/>${i18n.t('irrigation.wilting_point')} ${
          wiltingPoint ? Formatter.formatNumber(wiltingPoint) : '-'
        }
        <br/>${i18n.t('irrigation.saturation_point')} ${
          saturationPoint ? Formatter.formatNumber(saturationPoint) : '-'
        }
        <br/><br/>${soil.description}<br />
        ${
          soil.image
            ? `<img class="my-3" src="${this.getSrc(
                soil.image,
                'soil_images'
              )}" style="width: 100%;">`
            : ''
        }`;
      } catch (error) {
        return '';
      }
    },
    handlePlusBlock() {
      this.model.blocks_number++;
      this.model.name_blocks.push(null);
      this.model.blocks_rel.push(null);
      this.model.lots_rel.push([]);
      this.updateBlocks();
    },
    handleMinusBlock() {
      if (this.model.blocks_number > 1) {
        const index = this.model.blocks_number - 1;

        this.model.name_blocks.splice(index, 1);
        this.model.id_blocks.splice(index, 1);
        this.model.blocks_rel.splice(index, 1);
        this.model.lots_rel.splice(index, 1);

        this.model.blocks_number--;

        this.updateBlocks();
      }
    },
    handlePlusLot() {
      this.model.lots_number++;
      this.updateLots();
    },
    handleMinusLot() {
      if (this.model.lots_number > 1) {
        this.model.lots_number--;
        this.updateLots();
      }
    },
    handleDeleteLotByLot(index) {
      if (
        isset(this.model.name_lots[index] || isset(this.model.id_lots[index]))
      ) {
        SweetAlert.delete(
          `${i18n.t('common_words.allotment')}
        ${
          this.model.name_lots[index]
            ? ': ' + this.model.name_lots[index]
            : i18n.t('common_words.selected')
        }`
        ).then((result) => {
          if (result.value) {
            this.deleteLotSelected(index);
          }
        });
      } else {
        this.deleteLotSelected(index);
      }
    },
    deleteLotSelected(index) {
      if (isset(this.model.id_lots[index])) {
        this.model.id_lots = this.model.id_lots.filter((_, i) => i !== index);
      }
      if (isset(this.model.name_lots[index])) {
        this.model.name_lots = this.model.name_lots.filter(
          (_, i) => i !== index
        );
      }
      if (isset(this.model.code_lots[index])) {
        this.model.code_lots = this.model.code_lots.filter(
          (_, i) => i !== index
        );
      }
      if (isset(this.model.area_lots[index])) {
        this.model.area_lots = this.model.area_lots.filter(
          (_, i) => i !== index
        );
      }
      if (isset(this.model.crop_varieties_id[index])) {
        this.model.crop_varieties_id = this.model.crop_varieties_id.filter(
          (_, i) => i !== index
        );
      }
      if (isset(this.model.soilTypes[index])) {
        this.model.soilTypes = this.model.soilTypes.filter(
          (_, i) => i !== index
        );
      }
      if (isset(this.model.population[index])) {
        this.model.population = this.model.population.filter(
          (_, i) => i !== index
        );
      }
      this.model.lots_number--;
      this.model.lots_rel = this.model.lots_rel.map((subArray) =>
        subArray.filter((value) => this.model.name_lots.includes(value))
      );
    },
    handlePlusPackingHouse() {
      this.model.packing_house_number++;
      this.model.packing_houses = 1;
    },
    handleMinusPackingHouse() {
      if (this.model.packing_house_number > 0) {
        this.model.code_packing_houses.pop();
        this.model.name_packing_houses.pop();
        this.model.lots_packing_houses.pop();

        this.model.packing_house_number--;
      } else if (this.model.packing_house_number == 0) {
        this.model.packing_houses = 0;
      }
    },
    validateRepeatedCode() {
      if (!this.model.has_lot_code) return true;

      const validCodes = [];
      for (let i = 0; i < this.getNumberLots; i++) {
        const code = this.model.code_lots[i];
        if (code !== null && code !== undefined && String(code).trim() !== '') {
          validCodes.push(String(code).trim());
        }
      }

      const repeats = getRepeatsFromArray(validCodes);
      if (repeats.length > 0) {
        SweetAlert.warning(
          `${i18n.t('common_words.duplicate_codes_lots')} (${repeats.join(
            ', '
          )}), ${i18n.t('common_words.please_review_information')}`
        );
        return false;
      }
      return true;
    },
    validate() {
      let elThis = this;
      if (!this.model.has_lot_code) {
        this.clearLotCodes();
      }
      if (this.model.has_lot_code && !this.validateRepeatedCode()) {
        return Promise.resolve(false);
      }
      return this.$validator
        .validateAll()
        .then((res) => {
          const varieties =
            this.crop_varieties.length === 0
              ? this.varieties_crop
              : this.crop_varieties;

          this.$emit('on-validated', {
            ...this.model,
            code_lots: this.getPayloadCodeLots(),
            name_varieties: this.model.crop_varieties_id.map((varietyId) => {
              if (varietyId)
                return varieties.find((variety) => variety.id === varietyId)
                  .name;
              else return null;
            }),
            name_soils: this.model.soilTypes.map((soilId) => {
              if (soilId)
                return this.soilTypes.find((type) => type.id === soilId).name;
              else return null;
            }),
          });

          return res;
        })
        .then(() => {
          return store
            .dispatch('utils/validationInputsRequired', '-fourth-step')
            .then(function (response) {
              if (response) {
                if (elThis.model.lots_rel[0].length == 0) {
                  for (let index of document.getElementsByClassName(
                    'lot-rels'
                  )) {
                    let sel =
                      index.getElementsByClassName('el-input__inner')[0];
                    sel.focus();
                    sel.classList.add('custom-has-error');
                    store.dispatch('utils/removeHasError', sel);
                  }
                  return false;
                } else return true;
              }
            });
        });
    },
    async updateBlocks() {
      if (
        this.model.blocks_number &&
        this.model.blocks_number.toString().length <= 3
      ) {
        if (this.model.id_blocks.length > this.model.blocks_number) {
          this.model.id_blocks = this.model.id_blocks.splice(
            0,
            this.model.blocks_number
          );
        }
        let extra = this.model.name_blocks.splice(
          this.model.blocks_number,
          this.model.name_blocks.length
        );
        this.model.name_blocks = this.model.name_blocks.splice(
          0,
          this.model.blocks_number
        );

        extra.forEach((element) => {
          let index = this.model.blocks_rel.indexOf(element);
          if (index !== -1)
            this.model.blocks_rel = this.model.blocks_rel.splice(0, index);
        });

        this.setName(
          this.model.name_blocks,
          this.model.blocks_number,
          i18n.t('common_words.blocks_number')
        );
      }
    },
    getErrorField(nameField) {
      return this.errors.items.find((item) => item.field === nameField);
    },
    async setName(setName, lengthArray, nameField) {
      const e = await this.getErrorField(nameField);
      if (!e || (e && e.length <= 0)) {
        Array.from({ length: lengthArray }, (v, i) => i).forEach((j) => {
          if (!setName[j]) this.$set(setName, j, `${j + 1}`);
        });
      }
    },
    async updateLots() {
      if (
        this.model.lots_number &&
        this.model.lots_number.toString().length <= 3
      ) {
        if (this.model.id_lots.length > this.model.lots_number) {
          this.model.id_lots.splice(
            this.model.lots_number,
            this.model.id_lots.length - this.model.lots_number
          );
        }

        this.model.name_lots = this.model.name_lots;
        let extra = this.model.name_lots.splice(
          this.model.lots_number,
          this.model.name_lots.length
        );
        this.model.name_lots = this.model.name_lots.splice(
          0,
          this.model.lots_number
        );
        this.model.code_lots = this.model.code_lots.splice(
          0,
          this.model.lots_number
        );
        if (!this.model.has_lot_code) {
          this.clearLotCodes();
        }
        this.model.area_lots = this.model.area_lots.splice(
          0,
          this.model.lots_number
        );
        this.model.population = this.model.population.splice(
          0,
          this.model.lots_number
        );
        this.model.crop_varieties_id = this.model.crop_varieties_id.splice(
          0,
          this.model.lots_number
        );
        this.model.soilTypes = this.model.soilTypes.splice(
          0,
          this.model.lots_number
        );

        extra.forEach((element) => {
          this.model.lots_rel.forEach((item) => {
            let index = item.indexOf(element);
            if (index !== -1) item = item.splice(index, item.length);
          });
        });

        this.setName(
          this.model.name_lots,
          this.model.lots_number,
          i18n.t('common_words.allotment_number')
        );
      }
    },
  },

  computed: {
    typesOfSoil() {
      return [
        { id: 'arenoso', name: i18n.t('common_words.sandy') },
        { id: 'limo', name: i18n.t('common_words.silty') },
        { id: 'franco', name: i18n.t('common_words.loamy') },
        { id: 'arcilloso', name: i18n.t('common_words.clayey') },
        { id: 'calizo', name: i18n.t('common_words.calcareous') },
      ];
    },
    availableBlocks() {
      return this.model.name_blocks.filter(
        (block) => !this.model.blocks_rel.includes(block)
      );
    },
    avaliableVarieties() {
      if (this.crop_varieties.length === 0) {
        return this.varieties_crop;
      } else {
        return this.crop_varieties;
      }
    },
    getNumberBlocks() {
      if (
        this.model.blocks_number &&
        this.model.blocks_number.toString().length <= 3
      )
        return this.model.blocks_number;
      else return 0;
    },
    getNumberLots() {
      if (
        this.model.lots_number &&
        this.model.lots_number.toString().length <= 3
      )
        return this.model.lots_number;
      else return 0;
    },
    getNumberPackingHouse() {
      if (
        this.model.packing_house_number &&
        this.model.packing_house_number.toString().length <= 3
      )
        return this.model.packing_house_number;
      else return 0;
    },
    calculateArea() {
      return Formatter.formatNumber(
        getSumOfValorFromArray(this.model.area_lots)
      );
    },
    calculatePopulation() {
      return Formatter.formatNumber(
        getSumOfValorFromArray(this.model.population)
      );
    },
    predominantVariety() {
      const none = i18n.t('common_words.none');
      const mostRepeat = ArrayClass.getMostRepeatedValue(
        this.model.crop_varieties_id
      );

      if (mostRepeat && mostRepeat !== 'undefined') {
        const varieties =
          this.crop_varieties.length === 0
            ? this.varieties_crop
            : this.crop_varieties;

        const variety = varieties.find((variety) => variety.id == mostRepeat);

        return variety ? variety.name : none;
      } else return none;
    },
    predominantSoil() {
      const none = i18n.t('common_words.none');
      const mostRepeat = ArrayClass.getMostRepeatedValue(this.model.soilTypes);

      if (mostRepeat && mostRepeat !== 'undefined') {
        const soil = this.soilTypes.find((soil) => soil.id == mostRepeat);

        return soil ? soil.name : none;
      } else return none;
    },
  },

  mounted() {
    let editForm = {};
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Axios.getMasters('grounds/types/0').then((response) => {
        this.soilTypes = response.data.data;
        if (sessionStorage.getItem('editForm')) {
          editForm = JSON.parse(sessionStorage.getItem('editForm'));
          this.model.blocks_number = editForm.blocks_number;
          this.model.lots_number = editForm.lots_number;
          this.area_unit = editForm.area_unit;

          let packing_houses = editForm.packing_houses;
          if (packing_houses != 0) {
            this.model.packing_houses = 1;
            this.model.packing_house_number = packing_houses.length;

            packing_houses.map((element) => {
              this.model.code_packing_houses.push(element.code);
              this.model.name_packing_houses.push(element.name);

              let objLotRel = [];
              element.lots.forEach((item) => {
                objLotRel.push(item.name);
              });
              this.model.lots_packing_houses.push(objLotRel);
            });
          }

          editForm.blocks.forEach((element) => {
            if (element.deleted_at) return;

            this.model.id_blocks.push(element.id);
            this.model.name_blocks.push(element.name);
            this.model.blocks_rel.push(element.name);

            let objLotRel = element.lots.map((item) => item.name);
            this.model.lots_rel.push(objLotRel);
          });

          this.varieties_crop = editForm.crop.cropVarieties;

          let lots = editForm.lots ? editForm.lots : [];
          let hasCode = false;

          lots.forEach((element) => {
            this.model.id_lots.push(element.id);
            this.model.name_lots.push(element.name);
            this.model.code_lots.push(element.code || null);
            if (element.code) {
              hasCode = true;
            }
            this.model.area_lots.push(element.area);
            this.model.crop_varieties_id.push(element.crop_variety_id);
            this.model.population.push(element.population);
            this.model.soilTypes.push(element.soil_type_id);
          });
          if (hasCode || editForm.has_lot_code) {
            this.model.has_lot_code = true;
          }
        }
        this.showHideLoading();
      });
    } else this.showHideLoading();
  },
};
</script>
<style scoped>
.el-tooltip__popper .popper__arrow {
  display: none !important;
}
</style>
